/* eslint-disable
 no-eq-null,
 */
import assign from 'lodash/assign'

export default frAmount

/** @ngInject */
function frAmount() {
    return function (val, options) {
        const floatVal = parseFloat(val)
        const defaultOptions = { minimumFractionDigits: 2 }
        options = (options != null) ? assign({}, defaultOptions, options) : defaultOptions
        if (!isNaN(floatVal)) {
            return floatVal.toLocaleString('fr-FR', options)
        }
        return '- '
    }
}



// WEBPACK FOOTER //
// ./src/services/filters/frAmount.js